import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  ShiftStatusEnum,
  SHIFT_STATUS_BADGE_PROPS,
  BadgeVariant
} from '@umss/shared/utils';
import { UmssBadgeComponent } from '../badge/badge.component';

/**
 * Component to display a badge based on shift status.
 * Automatically selects the appropriate badge variant, label, and icon based on the shift status.
 */
@Component({
  selector: 'umss-shift-status-badge',
  standalone: true,
  imports: [UmssBadgeComponent],
  template: `
    @if (status && badgeProps) {
      <umss-badge
        [variant]="badgeProps.variant"
        [label]="badgeProps.label"
        [iconName]="badgeProps.iconName"
        [outlined]="badgeProps.outlined"
        [size]="size"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UmssShiftStatusBadgeComponent {
  private _status!: ShiftStatusEnum;

  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input({ required: true }) set status(value: ShiftStatusEnum) {
    this._status = value;
    this.badgeProps = SHIFT_STATUS_BADGE_PROPS[this._status];
  }
  get status(): ShiftStatusEnum {
    return this._status;
  }

  badgeProps:
    | {
        label: string;
        iconName?: string;
        variant: BadgeVariant;
        outlined: boolean;
      }
    | undefined;
}
